export const Config = {
  moduleName: "trainingV2",
  dependencies: [],
  label: "competence.app.trainingV2.label",
  urls: ["/szkolenia/:id"],
  routeName: "",
  routes: {},
  options: {},
  theme: {},
  ignoreModuleFromGlobalState: true,
};
